import * as moment from 'moment'
import * as React from 'react'
// import DatePicker from 'react-datepicker'
// import 'react-datepicker/dist/react-datepicker.css'
import { IServiceObject } from '../../../../types'
import UIMessages from '../../../../utils/ui-messages'
import CollapseIcon from '../../../icons/ui/CollapseIcon'
import ExpandIcon from '../../../icons/ui/ExpandIcon'
import TooltipIcon from '../../../icons/ui/TooltipIcon'
import { IMembershipSpecialObject } from './MembershipPane'
import { MembershipTypes } from 'src/constants/service'
import { Datepicker } from '@mobiscroll/react'
import { Checkbox, Input, Radio, Stepper, Select } from '@mobiscroll/react-latest'
import FormLabel from 'src/components/ui/form/FormLabel'
import { displayName } from 'react-notification-system'

interface IMembershipListItemProps {
  service: IServiceObject
  membership: IMembershipSpecialObject
  onUpdate: (membership: IMembershipSpecialObject) => any
}

interface IMembershipListItemState {
  expanded: boolean
  months: string[]
  numberTypes: IDropdownOption[]
}

interface IDropdownOption {
  text: string
  value: string
}

class MembershipListItem extends React.Component<IMembershipListItemProps, IMembershipListItemState> {
  constructor(props: any) {
    super(props)

    this.state = {
      expanded: false,
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      numberTypes: [
        { value: 'Total', text: 'Total' },
        { value: 'Week', text: 'Week' },
        { value: 'Month', text: 'Month' },
        { value: 'Year', text: 'Year' }
      ]
    }
  }

  public render() {
    const { service, membership } = this.props
    const membershipType = membership && membership.type ? membership.type.toLowerCase() : ''
    const innerContentStyle: any = {
      pointerEvents: membershipType === 'permanent' ? 'none' : 'auto',
      opacity: membershipType === 'permanent' ? 0.4 : 1.0,
      display: membershipType === 'permanent' ? 'none' : 'block'
    }
    const contentStyle: any = {
      pointerEvents: !membership.selected ? 'none' : 'auto',
      opacity: !membership.selected ? 0.4 : 1.0
    }

    return (
      <div className='mt1 mb2'>
        {/* TOP */}
        <div className='rounded bg-light-grey3 p1'>
          <div className='flex'>
            {/* TODO: Add tooltip for description */}
            <div className='membership-title-header'>
              <Checkbox checked={membership.selected} onChange={this.onToggle} />
              <span className='MembershipTitle bold h5'>{service.name}</span>
            </div>
            <div style={{ flex: 1 }}>
              <span className='ml2 h5'>Membership ID: </span>
              <span className='ml2 font-blue bold h5'>{membership.externalRiderId || 'None'}</span>
            </div>
            <div>
              {!this.state.expanded && (
                <div style={{ cursor: 'pointer' }} onClick={this.onToggleExpand}>
                  <ExpandIcon className='icon--small svg-stroke-grey3 mr1' />
                </div>
              )}
              {this.state.expanded && (
                <div style={{ cursor: 'pointer' }} onClick={this.onToggleExpand}>
                  <CollapseIcon className='icon--small svg-stroke-grey3 mr1' />
                </div>
              )}
            </div>
          </div>
        </div>
        {/* CONTENT */}
        {this.state.expanded && (
          <div style={contentStyle}>
            <div className='mt2'>
              <span>
                <FormLabel>{UIMessages.rider.externalMemberId}</FormLabel>
                <Input
                  onChange={this.onExternalId}
                  value={membership.externalRiderId}
                  className='mt02'
                  theme='ios'
                  themeVariant='light'
                />
              </span>
            </div>
            <div className='mt1'>
              <span>
                <Checkbox
                  className='DisallowPCACheckbox'
                  checked={membership.notAllowedPCA}
                  onChange={this.onToggleDisallowPCA}
                  label='Not allowed to have PCA'
                />
              </span>
            </div>
            {/* Eligibility */}
            <div className='mt1'>
              <FormLabel>{UIMessages.common.eligibilityForService}</FormLabel>
              <span>
                <Radio
                  checked={membershipType === MembershipTypes.PERMANENT}
                  onChange={this.onEligibilityPermanent}
                  label={UIMessages.common.permanent}
                />
                <Radio
                  checked={membershipType !== MembershipTypes.PERMANENT}
                  onChange={this.onEligibilityTemporary}
                  label={UIMessages.common.temporary}
                />
              </span>
            </div>
            {membershipType !== 'permanent' && (
              <div>
                <div className='mb1 mr3 bb-shadow-grey'>&nbsp;</div>
                <FormLabel>Eligibility Limitation Type</FormLabel>
              </div>
            )}

            {/* Limited day/time */}
            <div style={innerContentStyle} className='mt1'>
              <div>
                <Radio
                  className='LimitedDayTimeCheckbox'
                  checked={this.props.membership.isLimitedByDate}
                  onChange={this.onLimitedDayTimeCheckbox}
                  label={UIMessages.common.limitedDayAndTime}
                />
              </div>
              {this.props.membership.isLimitedByDate && (
                <div className='flex mt1'>
                  <div className='mr1 flex-column ios-datepicker pb1 col-6'>
                    <div className='datepicker-label'>{UIMessages.common.startDayAndTime}</div>
                    <div>
                      <Datepicker
                        controls={['calendar', 'time']}
                        dateFormat='MM/DD/YYYY'
                        max={moment(new Date())}
                        min={moment().subtract(100, 'years')}
                        value={this.props.membership.beginsAt ? moment(this.props.membership.beginsAt) : null}
                        onChange={this.onLimitedDateTimeStartChange}
                        theme='ios'
                        themeVariant='light'
                        inputStyle='box'
                        labelStyle='floating'
                        touchUi={false}
                        display='anchored'
                        calendarScroll='horizontal'
                      />
                    </div>
                  </div>
                  <div className='ml1 flex-column ios-datepicker pb1 col-6'>
                    <div className='datepicker-label'>{UIMessages.common.endDayAndTime}</div>
                    <div>
                      <Datepicker
                        controls={['calendar', 'time']}
                        dateFormat='MM/DD/YYYY'
                        max={moment(new Date())}
                        min={moment().subtract(100, 'years')}
                        value={this.props.membership.expiresAt ? moment(this.props.membership.expiresAt) : null}
                        onChange={this.onLimitedDateTimeEndChange}
                        theme='ios'
                        themeVariant='light'
                        inputStyle='box'
                        labelStyle='floating'
                        touchUi={false}
                        display='anchored'
                        calendarScroll='horizontal'
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* Number of rides */}
            <div style={innerContentStyle} className='mt1'>
              <div>
                <Radio
                  className='NumberOfRidesCheckbox'
                  checked={this.props.membership.isLimitedByNumberOfRides}
                  onChange={this.onNumberOfRidesCheckbox}
                  label={UIMessages.common.numberOfRides}
                />
              </div>
              {this.props.membership.isLimitedByNumberOfRides && (
                <div className='flex mt1 items-center'>
                  <Stepper
                    defaultValue={0}
                    value={this.props.membership.ridesNum}
                    onChange={this.onNumberOfRidesChange}
                    theme='material'
                    themeVariant='light'
                    inputStyle='box'
                  />
                  <label className='col-2 center h5 mr1'>{UIMessages.common.ridesPer}</label>
                  <span className='mt1'>
                    <Select
                      value={this.props.membership.ridesRangeType}
                      onChange={this.onridesRangeType}
                      data={this.state.numberTypes}
                      touchUi={false}
                      theme='ios'
                      themeVariant='light'
                      inputStyle='box'
                    />
                  </span>
                </div>
              )}
            </div>
            {/* Recurring */}
            <div style={innerContentStyle} className='mt1'>
              <div>
                <Radio
                  className='RecurringCheckbox'
                  checked={this.props.membership.isLimitedByRecurringMonths}
                  onChange={this.onRecurringCheckbox}
                  label={UIMessages.common.recurring}
                />
              </div>
              {this.props.membership.isLimitedByRecurringMonths && (
                <div className='flex flex-column mt1 ml1'>
                  <FormLabel>Choose Recurring Months:</FormLabel>
                  <div style={{ width: '30%' }} className='mt1 ml1 inline-block'>
                    {Object.keys(this.state.months).map((item, i) => (
                      <div style={{ width: '49%' }} className={'Month' + i + ' inline-block'} key={`tmli-${i}`}>
                        <Checkbox
                          checked={this.getRecurringMonthValue(this.state.months[item])}
                          onChange={this.onRecurringMonthChange(this.state.months[item])}
                          label={this.state.months[item]}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    )
  }

  private onLimitedDateTimeStartChange = (date: any) => {
    const copy = Object.assign({}, this.props.membership)
    copy.beginsAt = date.value
    this.props.onUpdate(copy)
  }

  private onLimitedDateTimeEndChange = (date: any) => {
    const copy = Object.assign({}, this.props.membership)
    copy.expiresAt = date.value
    this.props.onUpdate(copy)
  }

  private onNumberOfRidesChange = (event: any) => {
    const copy = Object.assign({}, this.props.membership)
    copy.ridesNum = Number(event.target.value)
    this.props.onUpdate(copy)
  }

  private onridesRangeType = (event: any) => {
    const copy = Object.assign({}, this.props.membership)
    copy.ridesRangeType = event.value
    this.props.onUpdate(copy)
  }

  private onRecurringMonthChange = (name: string) => () => {
    const copy = Object.assign({}, this.props.membership)
    if (!copy.recurringMonths) {
      copy.recurringMonths = []
    }
    if (copy.recurringMonths.includes(name)) {
      delete copy.recurringMonths[copy.recurringMonths.indexOf(name)]
      this.props.onUpdate(copy)
      return
    }
    copy.recurringMonths.push(name)
    this.props.onUpdate(copy)
  }

  private getRecurringMonthValue = (name: string) => {
    for (const i in this.props.membership.recurringMonths) {
      if (this.props.membership.recurringMonths[i] === name) {
        return true
      }
    }
    return false
  }

  private onLimitedDayTimeCheckbox = (event: any) => {
    const copy = Object.assign({}, this.props.membership)
    copy.isLimitedByDate = true
    copy.isLimitedByNumberOfRides = false
    copy.isLimitedByRecurringMonths = false
    this.props.onUpdate(copy)
  }

  private onNumberOfRidesCheckbox = (event: any) => {
    const copy = Object.assign({}, this.props.membership)
    copy.isLimitedByNumberOfRides = true
    copy.isLimitedByDate = false
    copy.isLimitedByRecurringMonths = false
    this.props.onUpdate(copy)
  }

  private onRecurringCheckbox = (event: any) => {
    const copy = Object.assign({}, this.props.membership)
    copy.isLimitedByRecurringMonths = true
    copy.isLimitedByDate = false
    copy.isLimitedByNumberOfRides = false
    this.props.onUpdate(copy)
  }

  private onEligibilityPermanent = (event: any) => {
    const copy = Object.assign({}, this.props.membership)
    copy.type = MembershipTypes.PERMANENT
    copy.isLimitedByNumberOfRides = false
    copy.isLimitedByDate = false
    copy.isLimitedByRecurringMonths = false
    this.props.onUpdate(copy)
  }

  private onEligibilityTemporary = (event: any) => {
    const copy = Object.assign({}, this.props.membership)
    copy.type = MembershipTypes.TEMPORARY_LIMITED_PERIOD
    copy.isLimitedByDate = true
    this.props.onUpdate(copy)
  }

  private onExternalId = (event: any) => {
    const copy = Object.assign({}, this.props.membership)
    copy.externalRiderId = event.target.value
    this.props.onUpdate(copy)
  }

  private onToggle = (event: any) => {
    const copy = Object.assign({}, this.props.membership)
    copy.selected = !copy.selected
    this.props.onUpdate(copy)
  }

  private onToggleExpand = () => {
    this.setState({
      expanded: !this.state.expanded
    })
  }

  private onToggleDisallowPCA = () => {
    const copy = Object.assign({}, this.props.membership)
    copy.notAllowedPCA = !copy.notAllowedPCA
    this.props.onUpdate(copy)
  }
}

export default MembershipListItem



// WEBPACK FOOTER //
// ./src/components/riders/editrider/membership/MembershipListItem.tsx